import { createContext, useContext } from 'react'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'

// Set around the controls linked to one object, such as a framework requirement or
// a policy, so each control's menu can offer to unlink it from that object.
export type UnlinkControlMenuContextType = {
  label: string
  onUnlink: (control: Control.AsObject) => void
  // Omitted when every listed control may be unlinked.
  canUnlink?: (control: Control.AsObject) => boolean
}

export const UnlinkControlMenuContext =
  createContext<UnlinkControlMenuContextType | null>(null)

export const useUnlinkControlMenu = (): UnlinkControlMenuContextType | null =>
  useContext(UnlinkControlMenuContext)
